import { v4 as uuidv4 } from 'uuid';
import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as tokml from "@fulcrumapp/tokml"
import { Events } from '../../firebase/telemetry'
import {
    FilterSection, FilterGroup, PresetChips, Stepper, Chip, ChipRow, filterStyles,
} from '../filters/FilterControls'

export const defaultDrillHoleColourSettings = (
    [
        {
            id: uuidv4(),
            moreThan: 2.5,
            color: "#800080"
        },
        {
            id: uuidv4(),
            moreThan: 1,
            color: "#FF0000"
        },
        {
            id: uuidv4(),
            moreThan: 0.1,
            color: "#FFA500"
        },
        {
            id: uuidv4(),
            moreThan: 0,
            color: "#0000FF"
        }
    ]);







export function DrillHoleQueryTool({
    drillHoleFilters,
    setDrillHoleFilters,
    drillHoleColourSettings,
    setDrilHoleColourSettings,
    drillHoleGeoJson }) {


    // ANUMBER Search

    // Hole Type
    // "AC"
    //"AUG"
    //"COST"
    //"DD"
    //"MT"
    //"PERC"
    //"RAB"
    //"RC"
    //"RM"
    //"SON"
    //"UNKN"
    //"VAC"
    //"WAT"

    function markersToKml() {

        const exportGeoJson = drillHoleGeoJson;

        exportGeoJson.features = exportGeoJson.features.slice(0,500);

        exportGeoJson.features = exportGeoJson.features.map((m) => {
            m.properties.kml_title = "AU G/T: " + m.properties.au_gpt.toFixed(2);
            m.properties.description =
              "\n Unique ID: " + m.properties.dhassayid +
              "\n AU G/T: " + m.properties.au_gpt.toFixed(2) +
              "\n A Number : " + m.properties.anumber +
              "\n From Depth (Sample) : " + m.properties.fromdepth +
              "\n To Depth (Sample) : " + m.properties.todepth +
              "\n Max Depth (Hole) : " + m.properties.maxdepth +
              "\n Hole Type : " + m.properties.holetype +
              "\n Company Sample ID: " + m.properties.companysampleid;
      
            return m
          })

        Events.exportGenerated('kml', 'drill_holes', exportGeoJson?.features?.length);

        var kml = tokml(exportGeoJson, { name: 'kml_title', description: 'description' });

        const url = window.URL.createObjectURL(new Blob([kml]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "samples.kml";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

    }


    // The shared controls hand back plain numbers rather than change events, so
    // these take a value directly. Empty string means "cleared" and is passed
    // through untouched - the query layer treats it as no bound.
    const setPpbLessThan = (v) => setDrillHoleFilters({ ...drillHoleFilters, gptlt: v });
    const setPpbMoreThan = (v) => setDrillHoleFilters({ ...drillHoleFilters, gptmt: v });
    const setMaxDepth = (v) => setDrillHoleFilters({ ...drillHoleFilters, maxDepth: v });

    // Grades a prospector actually cuts at: sub-gram anomalism through to
    // something worth walking onto.
    const GPT_PRESETS = [0.1, 0.5, 1, 5, 10];
    const DEPTH_PRESETS = [10, 25, 50];
    const GPT_NO_LIMIT = 9999;

    const removeRangeEntry = (id) => {

        setDrilHoleColourSettings(drillHoleColourSettings.filter((setting) => {
            if (setting.id !== id) {
                return true;
            } else return false;
        }))
    }

    const addRangeEntry = () => {

        setDrilHoleColourSettings([...drillHoleColourSettings, {
            id: uuidv4(),
            moreThan: 1234,
            color: "black"
        }])

    }

    const updateMoreThanValue = (id, value) => {
        const arr = drillHoleColourSettings.map((e) => {
            if (e.id === id) {
                e.moreThan = value;//value.target.valueAsNumber;
            }
            return e;
        });
        setDrilHoleColourSettings([...arr]);
    }

    const updateColourValue = (id, value) => {

        const arr = drillHoleColourSettings.map((e) => {
            if (e.id === id) {
                e.color = value.target.value;
            }
            return e;
        });
        setDrilHoleColourSettings([...arr]);
    }


    const to3dp = (number) => {
        return number.toFixed(2)
    }

    // Colour scale rows: swatch, then the threshold as a stepper, then the top of
    // the band derived from the next step up. Sorted high-to-low so it reads the
    // same way as the legend on the map.
    const colourScaleRows = (settings) => {
        const ordered = [...settings].sort((a, b) => b.moreThan - a.moreThan);
        return ordered.map((entry, i) => (
            <div
                key={entry.id}
                style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}
            >
                <input
                    type="color"
                    value={entry.color}
                    onChange={(val) => updateColourValue(entry.id, val)}
                    aria-label="Band colour"
                    style={{
                        width: 26, height: 26, padding: 0, flex: 'none', cursor: 'pointer',
                        border: '1px solid var(--gf-border-color, #E5E7EB)',
                        borderRadius: 7, background: 'transparent',
                    }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                    <Stepper
                        value={entry.moreThan}
                        unit="g/t"
                        step={0.1}
                        min={0}
                        onChange={(v) => updateMoreThanValue(entry.id, v)}
                    />
                </div>
                <span
                    style={{ ...filterStyles.meta, ...filterStyles.mono, flex: 'none' }}
                    title="Top of this band"
                >
                    {i === 0 ? '+' : `\u2013${to3dp(ordered[i - 1].moreThan - 0.01)}`}
                </span>
                <button
                    type="button"
                    onClick={() => removeRangeEntry(entry.id)}
                    aria-label="Remove this band"
                    style={{ ...filterStyles.pm, flex: 'none' }}
                >
                    <FontAwesomeIcon icon={faMinus} size="xs" />
                </button>
            </div>
        ));
    };

    return <>
        {/* One panel, no Simple/Advanced tabs. Every drill-hole filter fits in a
            single scroll once the fields are chips and steppers, and splitting
            three numbers across two tabs only hid the upper bound. */}
        <div style={{ padding: '0 2px' }}>
            <FilterSection
                first
                label="Au g/t — more than"
                action="Reset"
                onAction={() => setPpbMoreThan(0.1)}
            >
                <PresetChips
                    values={GPT_PRESETS}
                    value={drillHoleFilters.gptmt}
                    unit="g/t"
                    onChange={setPpbMoreThan}
                />
                <Stepper
                    value={drillHoleFilters.gptmt}
                    unit="g/t"
                    step={0.1}
                    min={0}
                    onChange={setPpbMoreThan}
                />
            </FilterSection>

            {/* 9999 is the "no upper limit" sentinel, not a real cut-off - it
                goes straight into a CQL BETWEEN, so clearing has to put the
                sentinel back rather than blank the field. */}
            <FilterSection
                label="Au g/t — less than"
                meta={drillHoleFilters.gptlt >= GPT_NO_LIMIT ? 'No upper limit' : undefined}
                action={drillHoleFilters.gptlt >= GPT_NO_LIMIT ? undefined : 'Clear'}
                onAction={() => setPpbLessThan(GPT_NO_LIMIT)}
            >
                <Stepper
                    value={drillHoleFilters.gptlt}
                    unit="g/t"
                    step={0.1}
                    min={0}
                    onChange={(v) => setPpbLessThan(v === '' ? GPT_NO_LIMIT : v)}
                />
            </FilterSection>

            <FilterGroup label="Max hole depth" summary={`${drillHoleFilters.maxDepth} m`}>
            <FilterSection meta="50 m queryable">
                <PresetChips
                    values={DEPTH_PRESETS}
                    value={drillHoleFilters.maxDepth}
                    unit="m"
                    onChange={setMaxDepth}
                />
                <Stepper
                    value={drillHoleFilters.maxDepth}
                    unit="m"
                    /* 5 m steps because the collar view precomputes the best
                       result at 5 m cutoffs and nothing finer exists. A 1 m
                       step would let you pick 21 m and silently serve the 20 m
                       answer. */
                    step={5}
                    min={0}
                    max={50}
                    onChange={setMaxDepth}
                />
            </FilterSection>

            </FilterGroup>

            <FilterGroup label="Export results" summary="top 500">
            <FilterSection>
                <ChipRow>
                    <Chip onClick={markersToKml} title="Download the visible drill holes as KML">
                        KML
                    </Chip>
                </ChipRow>
            </FilterSection>
            </FilterGroup>
        </div>

        <div style={{ padding: '0 2px 8px' }}>
            <FilterGroup label="Marker colour scale" summary={`${drillHoleColourSettings.length} bands`}>
            <FilterSection
                action="Reset"
                onAction={() => setDrilHoleColourSettings(defaultDrillHoleColourSettings)}
            >
                {colourScaleRows(drillHoleColourSettings)}
                <ChipRow>
                    <Chip onClick={addRangeEntry} title="Add another colour band">
                        + Add step
                    </Chip>
                </ChipRow>
            </FilterSection>
            </FilterGroup>
        </div>
    </>
}